import { PurchaseOrder } from '@/models/PurchaseOrder';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue } from 'vue-property-decorator';

@Component<CreatePurchaseOrderDialog>({})
export default class CreatePurchaseOrderDialog extends Vue {
  // #region @Props
  // #endregion

  // #region @Refs
  // #endregion

  // #region Props

  protected isLoading = false;

  protected purchaseOrder = new PurchaseOrder();

  protected isPurchaseOrderFormValid = false;

  // #endregion

  // #region Lifecycle Hooks / Init
  // #endregion

  // #region Handlers

  protected onClose(): void {
    this.$emit('input', false);
  }

  protected async onCreate(): Promise<void> {
    this.isLoading = true;

    await this.create();

    this.isLoading = false;
  }

  // #endregion

  // #region Helpers
  // #endregion

  // #region Async methods

  protected async create(): Promise<void> {
    if (
      ! (
        this.purchaseOrder
        && this.purchaseOrder.brand
        && this.purchaseOrder.supplier
      )
    ) { return; }

    if (this.purchaseOrder.brand && typeof this.purchaseOrder.brand === 'object') {
      this.purchaseOrder.brand = this.purchaseOrder.brand.id;
    }

    if (this.purchaseOrder.supplier && typeof this.purchaseOrder.supplier === 'object') {
      this.purchaseOrder.supplier = this.purchaseOrder.supplier.id;
    }

    if (this.purchaseOrder.master_data_status && typeof this.purchaseOrder.master_data_status === 'object') {
      this.purchaseOrder.master_data_status = (this.purchaseOrder.master_data_status as any).id;
    }

    if (this.purchaseOrder.status && typeof this.purchaseOrder.status === 'object') {
      this.purchaseOrder.status = (this.purchaseOrder.status as any).id;
    }

    try {
      this.purchaseOrder = await this.purchaseOrder
        .create(this.purchaseOrder);

      this.$emit('created');
    } catch (error) {
      ErrorHandler.network(error);
    }
  }

  protected get canCreate(): boolean {
    if (!this.purchaseOrder) { return false; }

    if (
      !this.purchaseOrder.brand
      || (
        typeof this.purchaseOrder.brand !== 'string'
        && !this.purchaseOrder.brand.id
      )
    ) { return false; }

    if (
      !this.purchaseOrder.supplier
      || (
        typeof this.purchaseOrder.supplier !== 'string'
        && !this.purchaseOrder.supplier.id
      )
    ) { return false; }

    return this.isPurchaseOrderFormValid;
  }

  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces
// #endregion
